import "./WorkoutModal.css";
import React from "react";
import { IoShareSocial, IoVideocam } from "react-icons/io5";
import placeHolder from "../../../images/placeholderGen.jpg";
import { BASE_URL_MEDIA } from "../../../api/Constants";
import { IoCalendarOutline } from "react-icons/io5";
import { FaRegEye } from "react-icons/fa";
import { FaDumbbell } from "react-icons/fa6";
import { MdSportsGymnastics } from "react-icons/md";
const imgageUrl = `${BASE_URL_MEDIA}/apis/storage/assets/uploads/`;

const WorkoutModal = ({ workout, handleShowModal, handleSowDescModal }) => {
  const data = [
    {
      icon: <IoCalendarOutline />,
      title: "weeks",
      value: workout?.number_of_weeks ? workout?.number_of_weeks : 0,
    },
    {
      icon: <FaDumbbell />,
      title: "workouts",
      value: workout?.workouts?.length > 0 ? workout?.workouts?.length : 0,
    },
    {
      icon: <MdSportsGymnastics />,
      title: "exercises",
      value: workout?.workouts?.reduce((acc, curr) => {
        return curr.exercises ? acc + curr.exercises.length : acc;
      }, 0),
    },
  ];

  const detailsWidgets = () => {
    return data.map((item, index) => {
      return (
        <div
          key={index}
          onClick={() => handleShowModal(workout)}
          className="deatil d-flex flex-column justify-content-center align-items-center col-3"
        >
          <div className="d-flex flex-row justify-content-center gap-1 align-items-center">
            <span className="value">{item.value}</span>
            <span className="icon">{item.icon}</span>
          </div>
          <span className="detail-title">{item.title}</span>
        </div>
      );
    });
  };
  return (
    <div className="workout-modal-outer pointer">
      <div className="workout-card">
        <div className="image-section">
          <img
            src={workout?.image ? imgageUrl + workout?.image : placeHolder}
            alt=""
            onClick={() => handleShowModal(workout)}
          />
        </div>
        <div className="share-icon" onClick={() => handleShowModal(workout)}>
          <IoShareSocial />
        </div>
        <div className="workout-info mt-2">
          <div className="name-section d-flex flex-row justify-content-between align-items-center gap-2 px-3">
            <span className="name" onClick={() => handleShowModal(workout)}>
              {workout?.name}
            </span>
            {workout?.video && (
              <span
                className="video"
                onClick={() => window.open(workout?.video, "_blank")}
              >
                <IoVideocam />
              </span>
            )}
          </div>
          {workout?.is_free == 0 && (
            <div
              className="price-section d-flex flex-row justify-content-start align-items-center gap-3 px-3"
              onClick={() => handleShowModal(workout)}
            >
              <span className="price">${workout?.price}</span>
              <span className="button">Subscribe</span>
            </div>
          )}

          <div className="row detail-list mt-2">
            {detailsWidgets()}
            <div
              className="deatil deatil-view d-flex flex-column justify-content-center align-items-center col-3"
              onClick={() => handleSowDescModal(workout)}
            >
              <div className="d-flex flex-row justify-content-center gap-1 align-items-center">
                <span className="icon">
                  <FaRegEye />
                </span>
              </div>
              <span className="detail-title">view</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WorkoutModal;
